import ModelService from "./abstract/ModelService";
import Vehicle from "../models/Vehicle";

export default class VehicleService extends ModelService {
  constructor() {
    super('/vehicles', Vehicle);
  }

  downloadExcel() {
    axios({
      url: config.app.api_url + this.modelPath + '/export/excel',
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', `vehicles.xlsx`);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  }

  searchByLicensePlateRdw(countryCode, licensePlate) {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + this.modelPath + '/license-plate/' + licensePlate + `/rdw?country_code=${countryCode}`).then(data => {
        resolve(data);
      }).catch(reject);
    });
  }

  searchByLicensePlateInternal(countryCode, licensePlate) {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + this.modelPath + '/license-plate/' + licensePlate + `/internal?country_code=${countryCode}`).then(data => {
        resolve(data);
      }).catch(reject);
    });
  }

  getAvailabilityChanges(vehicleIds, timestamp = null) {

    if (!timestamp) timestamp = Math.floor((new Date).getTime() / 1000);

    return new Promise((resolve, reject) => {
      this.post(config.app.api_url + this.modelPath + '/availability-changes', {
        timestamp: timestamp,
        vehicle_ids: vehicleIds
      }).then(data => {
        resolve(data);
      }).catch(reject);
    });
  }
}
